import 'babel-polyfill';
import { AppContainer } from 'react-hot-loader';
import React from 'react';
import ReactDom from 'react-dom';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';

import { initTestQuestions } from './actions';
import getQuestionSets from './utils/question-handler';

import reducer from './reducers';
import Root from './components/App';

import './images/favicon.ico';

import './images/share-game.png';
import './images/share-slogan-1.png';
import './images/share-slogan-2.png';
import './images/share-slogan-3.png';
import './images/share-slogan-4.png';
import './images/share-slogan-5.png';
import './images/share-slogan-6.png';
import './images/share-princess-1.png';
import './images/share-princess-2.png';
import './images/share-princess-3.png';
import './images/share-princess-4.png';
import './images/share-princess-5.png';
import './images/share-princess-6.png';

/* eslint-disable no-underscore-dangle */
const store = createStore(
  reducer,
  applyMiddleware(thunk),
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
/* eslint-enable */

store.dispatch(
  initTestQuestions(getQuestionSets())
);

const rootEl = document.getElementById('root');
const render = Component =>
  ReactDom.render(
    <Provider store={store}>
      <AppContainer>
        <Component />
      </AppContainer>
    </Provider>,
    rootEl
  );

render(Root);

if (module.hot) module.hot.accept('./components/App', () => render(Root));



// WEBPACK FOOTER //
// ./app/index.js